import { IBaseItem } from '@/utils/types/Items';
import { ICase } from '@/utils/types/ICaseBattle';

export default function getItemInfo(item: IBaseItem) {
    let itemType: string | null = null;
    let name: string | null = null;
    let itemName: string | null = null;
    let itemTypeLvl: number = 5;

    try {
        const matchResult = item.name.match(/\((['A-Za-z0-9- ]+)\)$/);
        if (matchResult) {
            itemType = matchResult[1];
        }
    } catch (err) {}

    try {
        const splitResult = item.name.split('|');
        if (splitResult.length > 1) {
            itemName = splitResult[1].trim().replace(/\((['A-Za-z0-9- ]+)\)$/giu, '');
        }
        name = splitResult[0].trim();

        if (item.appId == 440) {
            name = item.name.trim().replace(/\((['A-Za-z0-9- ]+)\)$/giu, '');
        }
    } catch (err) {}

    try {
        if (/Battle|Scarred|Worn/giu.test(itemType || '')) itemTypeLvl = 1;
        if (/Well|Worn/giu.test(itemType || '')) itemTypeLvl = 2;
        if (/Field|Tested/giu.test(itemType || '')) itemTypeLvl = 3;
        if (/Minimal|Wear/giu.test(itemType || '')) itemTypeLvl = 4;
        if (/Factory|New/giu.test(itemType || '')) itemTypeLvl = 5;
    } catch (err) {}

    return {
        name,
        itemName,
        itemType,
        price: item.priceUsd,
        itemTypeLvl,
    };
}

export function itemsValue(items: IBaseItem[]) {
    return items.reduce((accumulator, currentValue) => {
        if (currentValue?.priceUsd) {
            return accumulator + currentValue.priceUsd;
        } else return 0;
    }, 0);
}

export function compare(
    a: IBaseItem | ICase,
    b: IBaseItem | ICase,
    dropdownValue: 'highToLow' | 'lowToHigh'
) {
    switch (dropdownValue) {
        case 'highToLow':
            return a.priceUsd < b.priceUsd ? 1 : -1;
        case 'lowToHigh':
            return a.priceUsd > b.priceUsd ? 1 : -1;
        default:
            return b.priceUsd < a.priceUsd ? 1 : -1;
    }
}
